<template>
    <Modal v-if="showModal && message" modal-title="Please Confirm" @close="showModal = false">
        <template v-slot:body>
            <div class="my-2">
                <p class="text-gray-800">{{ message }}</p>
            </div>
        </template>
        <template v-slot:footer>
            <div class="float-right my-2">
                <my-button class="btn btn-line rounded-full" :disabled="processing" @click="showModal = false">
                    {{ options.confirm && options.confirm.no ? options.confirm.no : 'Cancel' }}
                </my-button>
                <my-button :loading="processing" class="btn btn-primary rounded-full ml-2" @click="triggerCallback">
                    {{ options.confirm && options.confirm.yes ? options.confirm.yes : 'Confirm' }}
                </my-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import { events } from './events';

export default {
    data() {
        return {
            message: 'Are you sure?',
            callback: null,
            options: {},
            processing: false,
            showModal: false
        };
    },

    mounted() {
        events.$on('open', this.open);
        events.$on('close', this.close);
    },

    methods: {
        open(message, callback, options = {}) {
            this.processing = false;
            this.message = message;
            this.callback = callback;
            this.options = options;
            this.showModal = true;
        },

        close() {
            this.showModal = false;
        },

        triggerCallback() {
            this.processing = true;

            Promise.resolve(this.callback())
                .then(response => {
                    this.close();
                    flash.success();

                    if (this.options.onSuccess) {
                        this.options.onSuccess(response);
                    }

                    return response;
                })
                .catch(error => {
                    if (this.options.onError) {
                        this.options.onError(error);
                    } else {
                        flash.error();
                    }

                    return error;
                })
                .finally(() => (this.processing = false));
        }
    }
};
</script>
